import {observable} from 'mobx';
import * as InfoApi from './InfoAPI';

export default class VersionKeeper {
    @observable public version: InfoApi.Version = {version: 'unknown', gitCommitId: 'unknown', buildDate: 'unknown'};
    public constructor() {
        InfoApi.version()
            .then((response) => (this.version = response.data))
            .catch(() => {
                /*no op*/
            });
    }
}



// WEBPACK FOOTER //
// ./src/info/VersionKeeper.ts